var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"container-overflow\"><div ng-if=\"!use_overflow\" class=\"text-container\"> <p ng-if=\"type != 'Website'\">{{displayText}}</p><a ng-if=\"type === 'Website'\" href=\"{{displayText}}\" target=\"_blank\">{{displayText}}</a></div><p ng-if=\"use_overflow\" ng-click=\"toggleToolTip()\" class=\"open-popup\">{{content}}</p><a ng-if=\"type != 'Email' &amp;&amp; type != 'Website'\" ng-class=\"{'active': toggled }\">{{displayText}}</a><a ng-if=\"type === 'Email'\" href=\"mailto:{{displayText}}\" ng-class=\"{'active': toggled }\">{{displayText}}</a><a ng-if=\"type === 'Website'\" href=\"{{displayText}}\" target=\"_blank\" ng-class=\"{'active': toggled }\">{{displayText}}</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/overflow/overflow.jade
// module id = 548
// module chunks = 0